import * as React from "react";
import { Translate } from "react-localize-redux";
import { translationKeys } from "../../../gen/translation-keys";

export const cancelLabel = <Translate id={translationKeys.assets.cancel} />;
export const submitLabel = <Translate id={translationKeys.assets.save} />;
